import { default as MuiGrid } from '@mui/material/Unstable_Grid2';
import { mergeSxStyle } from '../common/mergeSxStyle';

/**
 *
 * @param props
 * @constructor
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Grid = props => {
  const {
    children,
    sx,
    ...rest
  } = props;
  const mergedStyle = mergeSxStyle({}, sx);
  return /*#__PURE__*/_jsx(MuiGrid, {
    sx: mergedStyle,
    ...rest,
    children: children
  });
};

/*
TODO: Add fixed variant
We can add a fixed variant by applying max-width values based on the break points. We might need to create a wrapper container
that will center the grid within the container.  The Grid component will take a maxWidth value that could flex based on
the breakpoint.
We would need to add a fixed property to the Grid type definition
If the fixed property is true then we can set the maxWidth based on a media query, and center the grid.
Example:  https://stackoverflow.com/questions/49251454/grid-container-like-bootstrap-container
 */